import React from "react";
import TitleWithSwiper from "@components/swiper/TitleWithSwiper";
import styled from "@emotion/styled";
import { SwiperSlide } from "swiper/react";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";
import CuratedSellerCard from "@components/card/CuratedSellerCard";
import { useTheme } from "@emotion/react";

const BrandSwiperItem = styled(SwiperSlide)({
  display: "flex",
  flexGrow: 1,
  minWidth: "240px",
  maxWidth: "520px",
  cursor: "pointer",

  ".swiper-container": {
    overflow: "visible",
  },
});

const SellerSwiper = () => {
  const { getHomeSellerList } = useApiRequest();

  const { data: sellerList } = useQuery({
    queryKey: ["homeSellerList"],
    queryFn: getHomeSellerList,
  });

  return (
    <TitleWithSwiper
      title="취향저격 셀러 만나러가기"
      route="/search/seller"
      preview={2}
      space={0}>
      {sellerList?.map((item: any) => (
        <BrandSwiperItem key={item.seller_id}>
          <CuratedSellerCard
            nickname={item.nickname}
            src={item.profile_image}
            id={item.seller_id}
          />
        </BrandSwiperItem>
      ))}
    </TitleWithSwiper>
  );
};

export default SellerSwiper;
